export default "__VITE_ASSET__5OC55qPC__"